import { useSelector } from 'react-redux';

/**
 * Custom hook to access pages data from Redux store
 * @returns {Object} Pages state with customPages array, isLoading, and error
 */
export const usePages = () => {
  const { customPages, isLoading, error } = useSelector((state) => state.pages);

  return {
    customPages,
    isLoading,
    error,
  };
};
